import { render, staticRenderFns } from "./BlackGoldLangModal.vue?vue&type=template&id=d539f5a8&"
import script from "./BlackGoldLangModal.vue?vue&type=script&lang=js&"
export * from "./BlackGoldLangModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports